const getCategoryNavigationStepMapping = (category) => {
    switch (category) {
        case 'series':
            return { id: 0, name: 'series' };
        case 'basicModel':
            return { id: 1, name: 'basicModel' };
        case 'engine':
            return { id: 2, name: 'engine' };
        case 'paintwork':
            return { id: 3, name: 'paintwork' };
        case 'packages':
            return { id: 4, name: 'package' };
        case 'decor':
        case 'padding_cover':
        case 'fold':
        case 'roof_lining':
            return { id: 5, name: 'interior' };
        case 'special_equipment_basic_vehicle':
            return { id: 6, name: 'basicVehicle' };
        case 'special_equipment_la_strada':
            return { id: 7, name: 'optionalEquipment' };
        default:
            return null;
    }
};

export default getCategoryNavigationStepMapping;
